import { FC } from 'react'
import { Defect } from 'components/Defects'
import { UserProtectedRoute } from 'routes'
import { useHelpdeskTicketsList } from 'services/helpdesk/hooks'
import Section from 'components/Section'
import { CircularProgress } from '@mui/material'

const FaultsSinglePage: FC = () => {
  const { isLoading, isFetching } = useHelpdeskTicketsList()

  if (isFetching || isLoading) {
    return (
      <Section sx={{ flexDirection: 'column', alignItems: 'center' }}>
        <CircularProgress />
      </Section>
    )
  }

  return (
    <UserProtectedRoute>
      <Defect />
    </UserProtectedRoute>
  )
}

export default FaultsSinglePage
